export enum StationPort {
    N,
    NE,
    E,
    SE,
    S,
    SW,
    W,
    NW
}